import axios from "axios"
import baseURL from "../config/api"

export const getEmailChecking = (email: string, token: string, id?: string) => {
    const url = id
        ? `users/DoesEmailExist/${encodeURIComponent(email)}?id=${id}`
        : `users/DoesEmailExist/${encodeURIComponent(email)}`;

    return getFetch(url, token);
}

export const getFamilyMemberEmailChecking = (email: string, token: string, id?: string) => {
    const url = id
        ? `FamilyMember/DoesFamilyMemberEmailExist/${encodeURIComponent(email)}?id=${id}`
        : `FamilyMember/DoesFamilyMemberEmailExist/${encodeURIComponent(email)}`;

    return getFetch(url, token);
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}